import { render, staticRenderFns } from "./UserFormSignatures.vue?vue&type=template&id=64873ff9&scoped=true&"
import script from "./UserFormSignatures.vue?vue&type=script&lang=js&"
export * from "./UserFormSignatures.vue?vue&type=script&lang=js&"
import style0 from "./UserFormSignatures.vue?vue&type=style&index=0&id=64873ff9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64873ff9",
  null
  
)

export default component.exports